import React, { useEffect, useState } from 'react';
import Utils from './utils.js';
import Fetch from './fetch.js';
import { Button } from '@wordpress/components';
import { Flex, FlexBlock, FlexItem } from '@wordpress/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faPenFancy } from '@fortawesome/free-solid-svg-icons'
import { Modal } from "react-bootstrap";
import FontControl from './FontControl.js'
import FontName from './FontName'
import FontSlug from './FontSlug'

function Typography() {

    const [typography, setTypography] = useState([]);
    useEffect(() => {
        async function loadTypography() {
            const response = await fetch('/wp-json/davenport/v1/typography');
            if(!response.ok) {
                return;
            }
    
            const typ = await response.json();
            setTypography(typ);
        }
    
        loadTypography();
        
    }, [])

    const newFont = () => {
        setTypography([...typography, {fontFamily:"",name:"",slug:""}])
    }

    const [font, handleFontChange] = useState({idx:0,fontFamily:''})
    const [name, handleFontNameChange] = useState({idx:0,name:''})
    
    typography.map((typoFont, index) => {
        //update with child control states
        if(font.fontFamily != '' && font.idx == index){
            typoFont.fontFamily = font.fontFamily
        }
        if(name.name != '' && name.idx == index){
            typoFont.name = name.name
            typoFont.slug = Utils.kebabCase(name.name," ")
        }
    })

    const deleteFont = ( event, index ) => {
        typography.splice(index, 1);
        setTypography([...typography])
    }

    const saveTypography = ( event ) => {
        const inputs = JSON.stringify(typography)
        let params = {
			url : DBD.api_typography.url,
			nonce : DBD.api_typography.nonce,
			action : 'save_typography',
			data : inputs,
		};
			
        let noticeContainer = document.querySelector('.davenport-theme-options-notice');
		Fetch.send(params,function(message){
            Utils.setNotice(noticeContainer,message);
            localStorage.setItem('active-tab','typography');
            location.reload();
        });
    }

    const [ state, setState] = useState({showModal:false});
    const showModal = () => setState( {showModal:true} );
    const hideModal = () => setState( {showModal:false} );
    const MyModal = (props) => (<Modal show={props.isHidden} onHide={props.onClose}>
        <Modal.Header>
            <Modal.Title>CSS Root Variables</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {typography && typography.map((typoFont, index) => (
                <div key={index}>
                    --{typoFont.slug}:{typoFont.fontFamily};
                </div>
            ))}
            <hr />
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={props.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );

    return (
        <form>
            {typography && typography.map((typoFont, index) => (

                <Flex expanded="true" gap="30px" key={index}>
                    <FlexItem className="dbd-font-picker">
                        <FontControl 
                            font={(font.fontFamily && font.idx == index)? font.fontFamily : typoFont.fontFamily} 
                            idx={index}
                            handleFontChange={handleFontChange}
                        />
                    </FlexItem>
                    <FlexItem>
                        <FontName 
                            name={
                                //(font.fn != '' && font.idx == index ? font.fn :
                                (name.name != '' && name.idx == index) ? name.name : 
                                typoFont.name
                            } 
                            idx={index}
                            handleFontNameChange={handleFontNameChange} 
                        />
                    </FlexItem>
                    <FlexItem>
                        <FontSlug 
                            idx={index}
                            slug={typoFont.slug} 
                            inputValue={name} 
                        />
                    </FlexItem>
                    <FlexItem>
                        <FontAwesomeIcon 
                            icon={faTrash} 
                            size="sm" 
                            className="delete_font"
                            onClick={(e) => {deleteFont(e,index)}}
                        />
                    </FlexItem>
                </Flex>
            ))}

            <div className="typography-btns" style={{padding:'30px'}}>
                <Button className="btn btn-primary med" onClick={newFont}>
                    New Font <FontAwesomeIcon icon={faCirclePlus} />
                </Button>
                <Button 
                    className="btn btn-primary save-typography" 
                    onClick={(e) => {saveTypography(e)}}
                >
                    Save
                </Button>
                <MyModal isHidden={state.showModal} onClose={hideModal} />
                <Button className="btn btn-primary lg" id="get_typo_vars" onClick={showModal} style={{"float":"right"}}>
                    Get Root Variables <FontAwesomeIcon icon={faPenFancy} />
                </Button>
            </div>
        </form>
    )
}
export default Typography